import React, { useState, useEffect } from 'react';
import { testimonialService } from '../../services/adminService';
import './TestimonialApproval.css';

function TestimonialApproval({ apiBase, roleColor }) {
  const [testimonials, setTestimonials] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadTestimonials();
  }, []);

  const loadTestimonials = async () => {
    setLoading(true);
    try {
      const response = await testimonialService.listTestimonials({
        status: 'pending',
        limit: 50
      });
      if (response.ok && response.data) {
        setTestimonials(response.data.testimonials || []);
      }
    } catch (err) {
      console.error('Error loading testimonials:', err);
    } finally {
      setLoading(false);
    }
  };

  const handleApprove = async (id) => {
    try {
      await testimonialService.approveTestimonial(id);
      loadTestimonials();
    } catch (err) {
      alert('Error approving testimonial');
    }
  };

  const handleReject = async (id) => {
    const reason = prompt('Alasan penolakan:');
    if (reason) {
      try {
        await testimonialService.rejectTestimonial(id, reason);
        loadTestimonials();
      } catch (err) {
        alert('Error rejecting testimonial');
      }
    }
  };

  return (
    <div className="testimonial-approval">
      <h2>Approval Testimonial</h2>
      {loading ? (
        <div className="loading"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor"><circle cx="12" cy="12" r="10" /></svg>Memuat...</div>
      ) : testimonials.length === 0 ? (
        <div className="empty"><p>Tidak ada testimonial pending</p></div>
      ) : (
        <div className="testimonials-list">
          {testimonials.map(item => (
            <div key={item.id} className="testimonial-card">
              <div className="testimonial-header">
                <div>
                  <strong>{item.author_name}</strong>
                  <p className="email">{item.author_email}</p>
                </div>
                <span className="type-badge">{item.author_type}</span>
              </div>
              <p className="testimonial-content">"{item.content}"</p>
              {item.rating && <p className="rating">Rating: {item.rating}/5</p>}
              <div className="testimonial-actions">
                <button
                  className="btn-approve"
                  style={{ background: roleColor }}
                  onClick={() => handleApprove(item.id)}
                >
                  Setujui
                </button>
                <button className="btn-reject" onClick={() => handleReject(item.id)}>
                  Tolak
                </button>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

export default TestimonialApproval;
